import { Feature } from '../../components/feature';
import Button from '../../components/Button';

export default function Operator() {
  return  <Feature
        badge={"AI Powered OPERATIONS for Indian Schools"}
        title={"Save ₹25 Lakhs Every Year In Business Losses, Bring Calm, Clarity & Control."}
        description={
          <>
            <p>
              Great schools thrive on peace, not pressure. As schools expanded, paperwork and confusion increased. Teachers became busier, and communication faltered. SooMuch.ai was created to restore peace and purpose with AI.
            </p>
          </>
        }
        imageAlt="digital markting"
        imageQuery="images/new-landing-page/operatorv2.png"
        cta={
          <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
              <Button label='Book Live Demo' type='gradient' />
              <Button label="Claim ₹5 Lakh Free Access" type='outlined' />
            </div>
        }
      />
}